import { Institution } from '@backrs_ui/common-ui';

import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithAuth } from '../baseQuery';

export const institutionApi = createApi({
  reducerPath: 'institutionApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (build) => ({
    getInstitutionById: build.query<Institution, string>({
      query: (id) => `institutions/${id}`,
      keepUnusedDataFor: 60 * 60 * 24,
    }),
    getInstitutionByName: build.query<Institution, string>({
      query: (name) => `institutions/name/${name}`,
      keepUnusedDataFor: 60 * 60 * 24,
    }),
  }),
});

export const {
  useGetInstitutionByIdQuery,
  useGetInstitutionByNameQuery,
  usePrefetch: usePrefetchInstitution,
  util: { resetApiState },
} = institutionApi;
